import React from 'react';

import { ApolloProvider as NApolloProvider } from '@apollo/react-hooks';
import client from './client';

const ApolloProvider = ({ children }) => (
  <NApolloProvider client={client}>{children}</NApolloProvider>
);

export default ApolloProvider;
